<ul class="iackathon-progress-viewer__step-list">
    @for (step of steps; track step.id; let i = $index) {
        <li class="iackathon-progress-viewer__step-item">
            <button class="iackathon-progress-viewer__step-button"
                    [class.iackathon-progress-viewer__step-button--locked]="isStepLocked(step.id)"
                    [class.iackathon-progress-viewer__step-button--completed]="isStepCompleted(step.id)"
                    [class.iackathon-progress-viewer__step-button--selected]="activeState() === step.id"
                    [attr.aria-controls]="'iackathon-step-details'"
                    [attr.aria-pressed]="activeState() === step.id"
                    (click)="onStepClick(step.id)">
                <span class="iackathon-progress-viewer__step-button-label">
                    {{ step.labelKey | translate }}
                </span>
                <div class="iackathon-progress-viewer__step-button-icon-wrapper">
                    @if (isStepLocked(step.id)) {
                        <mat-icon svgIcon="lock-rounded-fill"></mat-icon>
                    } @else if (isStepCompleted(step.id)) {
                        <mat-icon svgIcon="check-rounded-700"></mat-icon>
                    }
                </div>
            </button>
        </li>
    }
</ul>

